import React, { Component } from 'react';
import {Route} from 'react-router-dom';
import {connect} from 'react-redux'
import {Helmet} from "react-helmet";

import {auth} from "../actions";

import AccountForm from '../components/AccountForm'


class Account extends Component{
  constructor() {
    super();
    this.state = {
      signOutStatus: false,
    }

    window.scrollTo(0, 0)
  }

  outsideClick(event) {
    event.stopPropagation();
  }

  signOutPopup() {
    return (
      <div className="signOutPopup" onClick={this.outsideClick}>
        <h3>Logga ut</h3>
        <p>Är du säker på att du vill logga ut?</p>
        <button className="Account-button signout" onClick={this.signOut}>
          Logga ut
        </button>
        <button className="Account-button" onClick={this.toggleSignOut}>
          Avbryt
        </button>
      </div>
    )
  }

  toggleSignOut = (event) => {
    event.preventDefault()
    this.setState(prevState => ({signOutStatus: !prevState.signOutStatus}))
  }

  signOut = (event) => {
    this.props.logout()
    this.toggleSignOut(event)
  }

  componentWillMount = () => {
    if (!this.props.isAuthenticated) {
      console.log("Not signed in")
    }
  }

  render() {
    return(
      <div className="Account-container container">
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>

        {
          this.state.signOutStatus
          ?
          <div className="signOutPopup-overlay" onClick={this.toggleSignOut}>
            {this.signOutPopup()}
          </div>
          :
          null
        }
        <div className="Account">
          <Route exact path='/konto' render={(props) =>
            <AccountForm
              toggleSignOut={this.toggleSignOut}
              token={this.props.token}
              deleteUser={this.props.deleteUser} />
          }/>
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => {
      return dispatch(auth.logout());
    },
    deleteUser: () => {
      return dispatch(auth.deleteUser());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/containers/Account.jsx